
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api`;

const getAuthUser = () => {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  return storedUser ? JSON.parse(storedUser) : null;
};

export const fetchBrands = async () => {
  const user = getAuthUser();

  if (!user?.id) {
    throw new Error("User session not found. Please login again.");
  }

  const response = await fetch(`${API_BASE_URL}/brands`, {
    method: "GET",
    headers: {
      "X-User-Id": String(user.id),
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch brands");
  }

  return await response.json();
};

export const updateBrand = async (brandId, brandName, logo = null) => {
  const user = getAuthUser();

  if (!user?.id) {
    throw new Error("User session not found. Please login again.");
  }

  const formData = new FormData();
  formData.append("brand_name", brandName);
  formData.append("status", "ACTIVE");

  if (logo) {
    formData.append("logo", logo);
  }

  const response = await fetch(`${API_BASE_URL}/brands/${brandId}`, {
    method: "PUT",
    headers: {
      "X-User-Id": String(user.id),
    },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || "Failed to update brand");
  }

  return await response.json();
};

